import styled, { css } from 'styled-components'
import { Link } from 'gatsby'

export const HeaderContainer = styled.div`
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 2;
  background: #fff;
`

export const HeaderWrapper = styled.div`
  width: 100%;
  height: 50px;
  background: #212328;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 18px;
  position: relative;
  border-bottom: 1px solid #eee;
  > div {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 12px;
    img {
      cursor: pointer;
      height: 30px;
    }
  }
  p {
    color: #a7b4c7;
    font-weight: 400;
  }
`

export const APITypeWrapper = styled.div`
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #eee;
`

export const APITypeInnerWrapper = styled.div`
  width: 1200px;
  height: 100%;
  display: flex;
  align-items: center;
  gap: 30px;
  margin: 0 auto;
`

export const HeadNavItem = styled(Link)`
  font-size: 14px;
  height: 60px;
  line-height: 60px;
  text-decoration: none;
  color: #000;
  font-weight: 600;
  ${({ active }) =>
    active &&
    css`
      color: #f2063f;
    `};
`

export const LayoutWrapper = styled.div`
  width: 100%;
  height: auto;
  min-height: 100vh;
  background: linear-gradient(to right, #f2f3f5 50%, #fff 50%);
  display: flex;
  justify-content: center;
`

export const LayoutInnerWrapper = styled.div`
  max-width: 1200px;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-wrap: nowrap;
  position: relative;
  margin: 0 auto;
  background: #fff;
`

export const ContentWrapper = styled.div`
  padding: 130px 0px 10px 10px;
  width: calc(100% - 430px);
  position: relative;
  margin: 0 auto;
`

export const LeftMenuWrapper = styled.div`
  min-width: 200px;
  height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 100px;
  overflow-y: auto;
  background: #f2f3f5;
  z-index: 5;
  padding: 20px 0;
  ::-webkit-scrollbar {
    width: 5px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: transparent;
  }
  &:hover {
    ::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.1);
    }
  }
`

export const HeaderRightPart = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
`

export const RightDrawer = styled.div`
  width: 130px;
  position: absolute;
  right: 5px;
  top: 60px;
  z-index: 9;
  border-radius: 5px;
  display: ${(p) => (p.show ? 'block' : 'none')};
  background: #212328;
  p {
    width: 100%;
    text-align: center;
    cursor: pointer;
  }
`

export const HeaderIconWrapper = styled.div`
  font-weight: 600;
  color: #a7b4c7;
  background: #11141c;
  border: 1px solid #3e4046;
  border-radius: 4px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  :hover {
    background: #30343e;
    color: #fff;
    border: 1px solid #b0b0b0;
    svg {
      path {
        fill: #fff;
      }
    }
  }
`

export const UserInfoWrapper = styled.div`
  background: #11141c;
  border: 1px solid #3e4046;
  border-radius: 4px;
  height: 30px;
  user-select: none;
  cursor: pointer;
  :hover {
    border: 1px solid #b0b0b0;
    color: #fff;
    ackground: #30343e;
  }
  > div:nth-child(1) {
    color: #bbc1ce;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    height: 100%;
    padding: 0 25px 0 5px;
    position: relative;
    > img {
      width: 12px;
      height: 12px;
      position: absolute;
      right: 8px;
      top: 8px;
      transform: ${({ show }) => (show ? 'rotate(180deg)' : 'rotate(0)')};
    }
  }
`

export const LetterAvater = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #4e5969;
  color: #fff;
  font-weight: bold;
  margin-right: 4px;
  text-align: center;
  line-height: 20px;
  font-size: 14px;
`
